export default __webpack_public_path__ + "static/media/avatar-4.5bfe7d01.jpg";